import { useStaticQuery, useStaticMutation } from '../../../helpers/useStaticData';
import { getGallery } from '../../../helpers/data';

export const useGetGalleryQuery = () => useStaticQuery(() => getGallery());

export const useAddMessageMutation = () => useStaticMutation();
